export default __webpack_public_path__ + "static/media/p7-8.b1cbb8a9.png";